const templateVariantSettings = {
  header: "COMPRESSED",
  homePage: "HomeTemplateV9",
  websiteName: "Eight FCU",
  speedBump: {
    borderWithRadious: true,
  },
  about: null,
  contact: null,
  footer: null,
};

module.exports = templateVariantSettings;
